import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import ProofOfPlayReportComponent from '../../../Components/ProofComponent/ProofOfPlayReportComponent'

function ProofOfPlayReport() {
    let navigate = useNavigate()
    let params=useParams()
  return (
    
    <div>
      <ProofOfPlayReportComponent navigate={navigate} id={params.id}></ProofOfPlayReportComponent>
    </div>
  )
}

export default ProofOfPlayReport
